/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import PricingBanner from "./PricingBanner.container";

export default PricingBanner;
